import { yearChanged } from "../actions/filters";
import makeSelect from "../../shared/make_select";

const valueSelector = (state) => state.main.filters.year.selectedValue;
const optionsSelector = (state) => state.main.filters.year.options;

export default makeSelect(yearChanged, "Choose a year", valueSelector, optionsSelector, { clearable: false }, { "col-md-3": true });
